import { IconProps } from '@atlaskit/icon';
import HomeCircleIcon from '@atlaskit/icon/glyph/home-circle';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from '../../i18n';

const DefaultIconContainer = ({ children }: { children: ReactNode }) => {
  const { formatMessage } = useIntl();
  return (
    <Box
      xcss={xcss({
        position: 'relative',
        width: '24px',
        height: '24px',
      })}
    >
      {children}
      <Inline
        xcss={xcss({
          position: 'absolute',
          top: 'space.150',
          left: 'space.150',
          backgroundColor: 'elevation.surface',
          borderRadius: 'border.radius.circle',
          width: '16px',
          height: '16px',
        })}
      >
        <HomeCircleIcon
          size="small"
          label={formatMessage(messages['views.default-view-icon-label'])}
          testId="default-view-indicator-icon"
        />
      </Inline>
    </Box>
  );
};

export interface LayoutIconProps {
  IconComponent: React.ComponentType<IconProps>;
  iconSize: 'small' | 'xlarge' | 'large' | 'medium';
  layoutType: { id: string; defaultMessage: string; description: string };
  isDefault: boolean;
  isPresentationOnly: boolean;
}

const LayoutIcon: React.FC<LayoutIconProps> = ({
  IconComponent,
  iconSize,
  layoutType,
  isDefault,
  isPresentationOnly,
}) => {
  const IconWrapper = ({ children }: { children: ReactNode }) => {
    return isDefault ? (
      <DefaultIconContainer>{children}</DefaultIconContainer>
    ) : (
      <>{children}</>
    );
  };

  const { formatMessage } = useIntl();

  return (
    <IconWrapper>
      <IconComponent
        size={iconSize}
        label={
          !isPresentationOnly
            ? formatMessage(messages['view-settings.layout.layout-text'], {
                layoutType: formatMessage(layoutType),
              })
            : ''
        }
      />
    </IconWrapper>
  );
};

export default LayoutIcon;
